// @flow
import React, {Component} from 'react';
import {View} from 'react-native';
import {IconBadge, Separator, Text} from 'trpc-react-native-ui';
import {ConfirmationModal} from '../../components/common';
import ExtraSlider from '../../components/topUp/ExtraSlider';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';
import RtlAwareStyleSheet from '../../lib/rtl-aware-stylesheet';
import OrderSummary from '../../components/order/OrderSummary';

function getStyles() {
  return RtlAwareStyleSheet.create({
    container: {
      backgroundColor: 'white',
      flex: 1,
    },
    innerContainer: {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'center',
      marginHorizontal: 10,
      paddingVertical: 20,
      paddingHorizontal: 10,
    },
    sliderContainer: {
      flex: 1,
      justifyContent: 'center',
    },
    text: {
      flex: 1,
      marginHorizontal: 10,
      rtlAware: {
        textAlign: 'left',
      },
    },
  });
}

class PurchaseExtra extends Component<Props> {
  componentDidMount() {
    this.props.initTopUp();

    if (this.props.shouldRefreshAvailable) {
      this.props.fetchAvailableTopUps();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (nextProps.shouldRefreshAvailable) {
      nextProps.fetchAvailableTopUps();
    }
  }

  render() {
    const styles = getStyles();
    return (
      <View style={styles.container}>
        <View style={styles.innerContainer}>
          <IconBadge
            iconName={theme.IAPPackages.EXTRA.icon}
            backgroundColor={theme.IAPPackages.EXTRA.colors[0]}
          />
          <Text style={styles.text}>{I18n.t('IAPPackages.EXTRA')}</Text>
        </View>
        <Separator />
        <View style={styles.sliderContainer}>
          <ExtraSlider
            extraTopUp={this.props.extraTopUp}
            onSelect={this.props.addTopUpToSelection}
            selectedTopUps={this.props.selectedTopUps}
          />
        </View>
        <Separator />
        <OrderSummary
          label={I18n.t('prepaidBudget')}
          message={I18n.t('prepaidBudgetMessage')}
          totalPrice={this.props.price}
        />
        <ConfirmationModal
          disabled={this.props.price === 0}
          onConfirm={this.props.onConfirm}
          openModalText={I18n.t('Dashboard.TopUp.topUpNow')}
          confirmContent={I18n.t('internationalAndPremiumConfirmContent')}
          title={I18n.t('confirmOrder')}
          isLoading={this.props.isConfirmationLoading}
        />
      </View>
    );
  }
}

type Props = {
  extraTopUp: Object[],
  selectedTopUps: Object,
  addTopUpToSelection: Function,
  fetchAvailableTopUps: Function,
  initTopUp: Function,
  price: number,
  onConfirm: Function,
  shouldRefreshAvailable: boolean,
  isConfirmationLoading: boolean,
};

export default PurchaseExtra;
